// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3ttgs","clinicsSelect":"TableHeading_clinicsSelect__176mo"};